export default __webpack_public_path__ + "static/media/IMG_1768 copie.f1f0a8ad.jpg";